import * as actions from "appRedux/actions/nightAudit/rateApproveType"

export type RateApproveType = {
    register_id: number
    room_number: string | null
    roomtype_id: number
    room_type: string | null
    roomtype_code: string | null
    arrival: string | null
    departure: string | null
    guest_name: string | null
    group_name: string | null
    channel_name: string | null
    booking_id: number
    booking_item?: number | null
    booking_rate_plan: string | null
    booking_rate_total: number | null
    actual_rate_plan: string | null
    actual_rate_total: number | null
    rate_diff: number | null
    approved: boolean
    approve_user: string | null
    approve_time: string | null
    checkin_user: string | null
    checkin_time: string | null
    upgrade_type: string | null
}

export type SummaryType = {
    meal: string | null
    adult: number
    child: number
    infant: number
    nights: number
    arrival: string | null
    balance: number | null
    deposit: number | null
    rooom_qty?: number | null
    block_qty?: number | null
    departure: string | null
    rate_plan: string | null
    extra_adult?: number | null
    extra_child?: number | null
    inhouse_qty?: number | null
    room_number?: string
    extra_infant: number | null
    total_charge: number | null
    include_adult: number | null
    include_child: number | null
    other_charges: Array<{
        amount: number | null
        description: string | null
    }>
    accommodations: Array<{
        amount: number | null
        description: string | null
    }>
    include_infant: number | null
    total_room_charge: number | null
    total_other_charge: number | null
}


export type rateApproveState = {
    loader: boolean
    dataSerialize: any
    dataSource: RateApproveType[]
    summaryDataSource?: SummaryType
    process: any
}

const INIT_STATE: rateApproveState = {
    loader: false,
    dataSerialize: {},
    dataSource: [],
    summaryDataSource: undefined,
    process: { status: false, action: "", message: "" }
}

export default (state: rateApproveState = INIT_STATE, action: actions.RateApproveAction): rateApproveState => {
    switch (action.type) {
        case actions.RATE_APPROVE_PREVIEW: {
            return {
                ...state,
                loader: false,
                process: { status: false, action: "", message: "" }
            }
        }
        case actions.RATE_APPROVE_UPDATE: {
            return {
                ...state,
                loader: true,
                process: { status: false, action: "", message: "" },
                dataSerialize: action.payload
            }
        }
        case actions.RATE_APPROVE_UPDATE_ALL: {
            return {
                ...state,
                loader: false,
                process: { status: false, action: "", message: "" },
                dataSerialize: action.payload
            }
        }
        case actions.RATE_APPROVE_PROCESS_SUCCESS: {
            return {
                ...state,
                loader: false,
                process: action.payload
            }
        }
        case actions.RATE_APPROVE_DATASOURCE_SUCCESS: {
            return {
                ...state,
                loader: false,
                dataSource: action.payload
            }
        }
        case actions.RATE_APPROVE_VIEW_SUMMARY: {
            return {
                ...state,
                summaryDataSource: undefined
            }
        }
        case actions.RATE_APPROVE_VIEW_SUMMARY_DATASOURCE: {
            return {
                ...state,
                summaryDataSource: action.payload
            }
        }
        case actions.RATE_APPROVE_PROCESS_RESET: {
            return {
                ...state,
                process: { status: false, action: "", message: "" }
            }
        }
        case actions.RATE_APPROVE_RESET: {
            return {
                ...state,
                loader: false,
                dataSerialize: {},
                dataSource: [],
                process: { status: false, action: "", message: "" }
            }
        }
        default:
            return state
    }
}